import { ICachedAddress } from '../models'
import { Language } from './literals-service'

class StorageService {
  private prefix = '@AMB'
  private keys = {
    language: `${this.prefix}:language`,
    routeName: `${this.prefix}:route`,
    isInstructionsExpanded: `${this.prefix}:isInstructionsExpanded`,
    cachedAddresses: `${this.prefix}:cachedAddresses`
  }

  public setLanguage(language: Language): void {
    return this.setByKey(this.keys.language, language)
  }

  public getLanguage(): Language {
    return this.getByKey(this.keys.language)
  }

  public removeLanguage(): void {
    return this.removeByKey(this.keys.language)
  }

  public setRouteName(routeName: string): void {
    return this.setByKey(this.keys.routeName, routeName)
  }

  public getRouteName(): string {
    return this.getByKey(this.keys.routeName)
  }

  public removeRouteName(): void {
    return this.removeByKey(this.keys.routeName)
  }

  public async setIsInstructionsExpanded(isInstructionsExpanded: boolean): Promise<void> {
    return this.setByKey(this.keys.isInstructionsExpanded, isInstructionsExpanded)
  }

  public async removeInstructionsExpanded(): Promise<void> {
    return this.removeByKey(this.keys.isInstructionsExpanded);
  }

  public async getIsInstructionsExpanded(): Promise<boolean> {
    return this.getByKey(this.keys.isInstructionsExpanded)
  }

  public getCachedAddresses(): ICachedAddress[] {
    const stored = this.getByKey(this.keys.cachedAddresses)
    return Array.isArray(stored) ? stored : []
  }

  public setCachedAddresses(addresses: ICachedAddress[]): void {
    return this.setByKey(this.keys.cachedAddresses, addresses)
  }

  private getByKey(key: string): any {
    try {
      const value = localStorage.getItem(key)
      return value ? JSON.parse(value) : null
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error(error)
    }
  }

  private setByKey(key: string, value: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error(error)
    }
  }

  private removeByKey(key: string): any {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error(error)
    }
  }
}

export default new StorageService()
